// extracted by mini-css-extract-plugin
export default {"closeBtn":"PlasmicCloseButton_closeBtn__qaKSx","svg":"PlasmicCloseButton_svg__0ysWa"};